<template>
  <el-row type="flex" justify="center">
    <el-col :xs="24" :sm="16">
      <el-card>
        <div slot="header"></div>
        <div v-if="page === 1">
          <q-title :title="title">
            <div v-html="subtitle"></div>
          </q-title>
          <div class="form">
            <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-position="left"
              size="medium"
            >
              <el-form-item label="单位" prop="company">
                <el-input v-model="form.company"></el-input>
              </el-form-item>
              <el-form-item label="地方（地级及以上行政区划）" prop="region">
                <el-input v-model="form.region"></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="contact">
                <el-input v-model="form.contact"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <q-term align="center">
            <el-button type="primary" @click="nextPage">下一页</el-button>
            <span class="paginator-span">第1页/共2页</span>
          </q-term>
        </div>
        <div v-if="page === 2">
          <q-term title="4. 法规政策">
            <span>
              当地已公布的有关公共数据开放、公共数据授权运营、公共数据开发利用的法规政策文本，包括地方性法规、地方政府规章、一般规范性文件以及部门规范性文件等。尚未对外公布的法规政策不纳入征集范围。
              <br />
              内容要求：(1)专门针对公共数据开放、公共数据授权运营、公共数据开发利用的政策法规；(2)涉及公共数据开放、公共数据授权运营、公共数据开发利用的政策法规，如数据条例、公共（政务）数据管理办法等。
            </span>
          </q-term>
          <q-term>
            <q-table
              :schema="q4.schema"
              v-model="q4.data"
              :multiple="true"
            ></q-table>
          </q-term>
          <q-term title="">
            <q-upload v-model="q4.files"></q-upload>
          </q-term>
          <q-term title="5. 主管部门与内设处室" class="item-space">
            <q-table
              :schema="q5_1.schema"
              v-model="q5_1.data"
              :multiple="true"
            ></q-table>
          </q-term>
          <q-term title="">
            <q-upload v-model="q5_1.files"></q-upload>
          </q-term>
          <q-term>
            <q-table :schema="q5_2.schema" v-model="q5_2.data" :multiple="true">
            </q-table>
          </q-term>
          <q-term>
            <q-upload v-model="q5_2.files"></q-upload>
          </q-term>
          <q-term
            title="6. 涉及公共数据开放或授权运营工作的数字政府领域相关方案与规划类文件"
            class="item-space"
          >
            <span>
              如《XX省“数字政府”建设规划（2020—2025年）》《XX市数字政府建设“十四五”规划》等。
            </span>
          </q-term>
          <q-term>
            <q-table
              :schema="q6.schema"
              :multiple="true"
              v-model="q6.data"
            ></q-table>
          </q-term>
          <q-term>
            <q-upload v-model="q6.files"></q-upload>
          </q-term>
          <q-term title="7. 数据开放年度工作计划" class="item-space">
            <span
              >2024年以来，专门针对公共数据开放的年度工作计划，如《XX市公共数据开放2024年度工作要点》。</span
            >
          </q-term>
          <q-term>
            <q-table
              :schema="q7.schema"
              :multiple="true"
              v-model="q7.data"
            ></q-table>
          </q-term>
          <q-term title="年度工作计划（需已经对外公开发布）">
            <q-upload v-model="q7.files"></q-upload>
          </q-term>
          <q-term title="8. 数据开放年度重点清单" class="item-space">
            <span>
              2024年以来，专门针对公共数据开放的年度重点清单，如《XX市公共数据开放2024年度重点清单》。
            </span>
          </q-term>
          <q-term>
            <q-table :schema="q8.schema" v-model="q8.data" :multiple="true">
            </q-table>
          </q-term>
          <q-term title="年度数据开放清单（需已经对外公开发布）">
            <q-upload v-model="q8.files"></q-upload>
          </q-term>
          <q-term title="9. 授权运营通告">
            <span>
              当地针对授权运营制定和公布的授权运营场景征集公告或授权运营场景公布通告。
            </span>
          </q-term>
          <q-term>
            <q-table :schema="q9.schema" v-model="q9.data" :multiple="true">
            </q-table>
          </q-term>
          <q-term>
            <q-upload v-model="q9.files"></q-upload>
          </q-term>
          <q-term title="10. 省域标准规范" class="item-space">
            <span
              >（1）当地针对数据开放或授权运营制定和公布的标准、规范或指引类文件；（2）省域明确标明贯彻落实国家数据开放和授权运营标准规范的文件。非省级地方不用填写。</span
            >
          </q-term>
          <q-term title="">
            <q-upload v-model="q10.files"></q-upload>
          </q-term>
          <q-term title="11. 公共数据授权运营平台或栏目" class="item-space">
            <span>如地方已上线了公共数据授权运营平台或栏目，可提供链接。</span>
          </q-term>
          <q-term>
            <q-table
              :schema="q11.schema"
              v-model="q11.data"
              :multiple="true"
            ></q-table>
          </q-term>
          <q-term title="12. 高容量数据" class="item-space">
            <span>
              地方数据开放平台上无条件开放的可下载数据集中，请推荐最多十个容量相对最大的数据集。
              <br />
              （数据容量是指将一个可下载的、结构化的有效数据集的字段数（列数）乘以条数（行数）后得出的数据量。例如：一张数据表有10行，5列，数据容量为50）。
            </span>
          </q-term>
          <q-term title="">
            <q-table
              :schema="q12.schema"
              v-model="q12.data"
              :limit="10"
              :multiple="true"
            ></q-table>
          </q-term>
          <q-term title="13. 优质API接口">
            <span>
              地方数据开放平台上无条件开放的数据集中，请推荐五个有代表性的优质API接口。
              （优质API是指平台上可获取、可调用、实时动态更新、数据容量较高的API接口。）
            </span>
          </q-term>
          <q-term title="">
            <q-table
              :schema="q13.schema"
              :multiple="true"
              v-model="q13.data"
            ></q-table>
          </q-term>
          <q-term title="14. 数据开放利用比赛" class="item-space">
            <span
              >2022年以来举办的数据开放利用比赛（综合型或专业领域型）。</span
            >
          </q-term>
          <q-term>
            <q-table
              :schema="q14.schema"
              :multiple="true"
              v-model="q14.data"
              :use-textarea="true"
            >
            </q-table>
          </q-term>
          <q-term title="15. 其他引导赋能活动" class="item-space">
            <span
              >2022年以来公开举办的有助于促进数据开放利用的活动，例如公共数据供需对接会、数据开放利用宣传交流研讨活动等，需要有公开报道。</span
            >
          </q-term>
          <q-term>
            <q-table
              :schema="q15.schema"
              :multiple="true"
              v-model="q15.data"
              :use-textarea="true"
            >
            </q-table>
          </q-term>
          <q-term title="16. 授权运营应用场景">
            <span>
              通过公共数据授权运营产出的应用场景，应用场景需要已经落地，有公开报道和获取渠道。
            </span>
          </q-term>
          <q-term>
            <q-table :schema="q16.schema" :multiple="true" v-model="q16.data">
            </q-table>
          </q-term>
          <q-term>
            <q-upload v-model="q16.files"></q-upload>
          </q-term>
          <q-term title="17. 其他相关公开材料"> </q-term>
          <q-term title="">
            <q-upload v-model="q17.files"></q-upload>
          </q-term>
          <q-term align="center">
            <el-button type="primary" @click="previousPage">上一页</el-button>
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <span class="paginator-span">第2页/共2页</span>
          </q-term>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
const numbers = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];

import QTitle from "./QTitle";
import QTerm from "./QTerm";
import QUpload from "./QUpload";
import { add20220922 } from "@/api/questionaire";
import QTable from "./QTable.vue";
export default {
  components: { QTerm, QUpload, QTitle, QTable },
  data() {
    return {
      page: 1,
      title: "“中国开放数林指数”地方信息征集表 (2024 )",
      subtitle: `<br>
      “中国开放数林指数”是我国首个专注于评估政府数据开放利用水平的专业指数，由复旦大学数字与移动治理实验室制作出品。开放数据，蔚然成林，“开放数林”意喻我国政府数据开放利用的生态体系，自 2017 年首次发布以来，定期对我国地方政府数据开放利用水平进行综合评价，精心测量各地“开放数木”的生长态势和成果价值，助推我国公共数据开放利用生态体系的建设与发展。
                    <br>
                    <br>
      “中国开放数林指数“的成长，得到了各地的大力支持。报告发布方对部分指标的采集采取了以报告发布方自主采集+向各地征集相结合的方式，欢迎各地主动提供有关政府数据开放利用工作的信息和动态。`,
      form: {
        company: "",
        region: "",
        contact: ""
      },
      rules: {
        company: [{ required: true, message: "请填写此项", trigger: "blur" }],
        region: [{ required: true, message: "请填写此项", trigger: "blur" }],
        contact: [{ required: true, message: "请填写此项", trigger: "blur" }]
      },
      q4: {
        schema: [
          {
            key: "documentNo",
            label: "文号"
          },
          {
            key: "url",
            label: "发布链接"
          }
        ],
        data: [],
        files: []
      },
      q5_1: {
        schema: [
          {
            key: "departmentName",
            label: "公共数据开放的主管部门名称"
          },
          {
            key: "departmentProperty",
            label: "主管部门性质"
          },
          {
            key: "superDepartment",
            label: "上级主管部门（如没有，请填无）"
          },
          {
            key: "internalDepartments",
            label:
              "部门内部负责数据开放工作的处室名及其职能（需附上网址或相关文件证明）"
          }
        ],
        data: [],
        files: []
      },
      q5_2: {
        schema: [
          {
            key: "departmentName",
            label: "公共数据授权运营的主管部门名称"
          },
          {
            key: "departmentProperty",
            label: "主管部门性质"
          },
          {
            key: "superDepartment",
            label: "上级主管部门（如没有，请填无）"
          },
          {
            key: "internalDepartments",
            label:
              "部门内部负责数据开放工作的处室名及其职能（需附上网址或相关文件证明）"
          }
        ],
        data: [],
        files: []
      },
      q6: {
        schema: [
          {
            key: "schemaName",
            label: "文件名称"
          },
          {
            key: "url",
            label: "发布链接"
          },
          {
            key: "plan",
            label: "相关内容"
          }
        ],
        data: [],
        files: []
      },
      q7: {
        schema: [
          { key: "plan", label: "文件名称" },
          { key: "url", label: "发布链接" }
        ],
        data: [],
        files: []
      },
      q8: {
        schema: [
          { key: "filename", label: "文件名称" },
          { key: "url", label: "发布链接" }
        ],
        data: [],
        files: []
      },
      q9: {
        schema: [
          { key: "filename", label: "文件名称" },
          { key: "url", label: "发布链接" }
        ],
        data: [],
        files: []
      },
      q10: {
        files: []
      },
      q11: {
        schema: [
          {
            key: "platformName",
            label: "平台/栏目名称"
          },
          {
            key: "url",
            label: "平台/栏目链接"
          }
        ],
        data: []
      },
      q12: {
        schema: [
          {
            key: "datasetName",
            label: "数据集名称"
          },
          {
            key: "url",
            label: "数据集链接"
          }
        ],
        data: []
      },
      q13: {
        schema: [
          {
            key: "apiName",
            label: "API接口名称"
          },
          {
            key: "url",
            label: "接口链接"
          }
        ],
        data: []
      },
      q14: {
        schema: [
          {
            key: "brief",
            label: "大赛简介"
          },
          {
            key: "url",
            label: "官网链接"
          }
        ],
        data: []
      },
      q15: {
        schema: [
          {
            key: "brief",
            label: "活动简介"
          },
          {
            key: "url",
            label: "公开报道链接"
          }
        ],
        data: []
      },
      q16: {
        schema: [
          { key: "casename", label: "授权运营应用场景名称" },
          { key: "brief", label: "简介" },
          { key: "url", label: "公开报道链接" }
        ],
        data: [],
        files: []
      },
      q17: {
        // data: "",
        files: []
      }
    };
  },
  mounted() {
    console.log("env", process.env);
  },
  methods: {
    nextPage() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.page++;
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit() {
      const questions = {
        q4: this.q4,
        q5_1: this.q5_1,
        q5_2: this.q5_2,
        q6: this.q6,
        q7: this.q7,
        q8: this.q8,
        q9: this.q9,
        q10: this.q10,
        q11: this.q11,
        q12: this.q12,
        q13: this.q13,
        q14: this.q14,
        q15: this.q15,
        q16: this.q16,
        q17: this.q17
      };

      const questionaire = {
        organization: this.form.company,
        city: this.form.region,
        phone: this.form.contact,
        data: JSON.stringify(questions)
      };

      this.$alert("确认是否提交问卷", "提交", {
        confirmButtonText: "确定",
        callback: () => {
          add20220922(questionaire)
            .then(response => {
              console.log(response);
              const success = response.status === 200;
              this.$message({
                type: success ? "info" : "danger",
                message: success ? "提交成功" : response.msg
              });
            })
            .catch(err => {
              this.$message.error("提交错误 " + err);
            });
        }
      });
    },
    previousPage() {
      this.page--;
    },
    q3_addRow(index) {
      // console.log("add row", index);
      if (this.q3.data.length < 10) {
        this.q3.data.splice(index + 1, 0, {
          item: `规划${numbers[index + 1]}`,
          plan: "",
          schemaName: "  ",
          url: ""
        });
        this.q3_refreshRow();
      }
    },
    q3_deRow(index) {
      // console.log("delete row");
      if (this.q3.data.length === 1) {
        this.q3.data = [
          { item: "规划一", plan: "", schemaName: "  ", url: "" }
        ];
      } else {
        this.q3.data.splice(index, 1);
        this.q3_refreshRow();
      }
    },
    q4_addRow(index) {
      // console.log("add row", index);
      if (this.q4.urls.length < 10) {
        this.q4.urls.splice(index + 1, 0, {
          item: `网址${numbers[index + 1]}`,
          url: ""
        });
        this.q4_refreshRow();
      }
    },
    q4_deRow(index) {
      // console.log("delete row");
      if (this.q4.urls.length === 1) {
        this.q4.urls = [{ item: "网址一", url: "" }];
      } else {
        this.q4.urls.splice(index, 1);
        this.q4_refreshRow();
      }
    },
    q3_refreshRow() {
      // console.log("refresh row");
      this.q3.data.forEach((e, i) => {
        e.item = `规划${numbers[i]}`;
      });
    },
    q4_refreshRow() {
      this.q4.urls.forEach((e, i) => {
        e.item = `网址${numbers[i]}`;
      });
    }
  }
};
</script>

<style>
.el-upload-dragger {
  height: 50px;
}
.form {
  width: 70%;
  margin: 45px 0 30px 0;
}
.table-less {
  width: 100%;
}
.table-less .el-input__inner {
  border: none;
  padding: 0;
}
.body {
  width: 60%;
}
.label {
  font-size: 0.14rem;
  white-space: pre-wrap;
  text-align: left;
  word-break: break-all;
  padding-bottom: 4px;
}
.el-card__header {
  background-color: rgb(18, 98, 3);
}
.item-space {
  margin-top: 25px;
}
.paginator-span {
  padding: 9px 0 0 38px;
  font-size: 13px;
  color: #999;
}
</style>
